export const RECAPTCHA_ACTION = "financial_report";
